import {
    SET_NAVBAR_ACTIVE
   ,SET_NAV_MENU_OPEN
} from '../constants';

export const setNavBarActive = value => (
    {
        type: SET_NAVBAR_ACTIVE,
        value
    }
);

export const setNavMenuOpen = value => (
    {
        type: SET_NAV_MENU_OPEN,
        value
    }
);
